module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-2.fb0f73c5.png";